module.exports = __webpack_public_path__ + "static/img/meeting-hotel.922c2197.jpg";